import { render, staticRenderFns } from "./DvManageableComboItem.vue?vue&type=template&id=25a0cd9e&lang=pug"
import script from "./DvManageableComboItem.vue?vue&type=script&lang=js"
export * from "./DvManageableComboItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports